export { default } from './FrontPageContainer';